// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-group {
    position: relative;
    margin-bottom: 16px;
  }
  
  .form-input {
    width: 100%;
    padding: 10px 35px 10px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .input-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #666;
  }
  
  .login-box .error-text {
    color: red;
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 0;
  }
  
  .input-error {
    border-color: red;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/FormFields/InputField.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,UAAU;IACV,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB","sourcesContent":[".input-group {\n    position: relative;\n    margin-bottom: 16px;\n  }\n  \n  .form-input {\n    width: 100%;\n    padding: 10px 35px 10px 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n  \n  .input-icon {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #666;\n  }\n  \n  .login-box .error-text {\n    color: red;\n    font-size: 12px;\n    margin-top: 5px;\n    margin-bottom: 0;\n  }\n  \n  .input-error {\n    border-color: red;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
